import { inject as Inject } from 'inversify-props';

export default Inject;
